import _defineProperty from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["inputRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import IMaskMixin from './mixin.js';
import 'prop-types';
import 'imask/esm/imask';
var IMaskInputClass = IMaskMixin(function (_ref) {
  var inputRef = _ref.inputRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return React.createElement('input', _objectSpread(_objectSpread({}, props), {}, {
    ref: inputRef
  }));
});
var IMaskInputFn = function IMaskInputFn(props, ref) {
  return React.createElement(IMaskInputClass, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
} // TODO fix no idea
;

var IMaskInput = React.forwardRef(IMaskInputFn);
export { IMaskInput as default };